var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-type",class:_vm.getAccountCLass(_vm.accountType)},[_vm._v(" "+_vm._s(_vm.accountType)+" account ")])
}
var staticRenderFns = []

export { render, staticRenderFns }